import React, { createContext, useContext } from "react";

export type TileImageTeaserMode = "image-top" | "image-right";

export type TileImageTeaserContext = {
  mode: TileImageTeaserMode;
};

const TileImageTeaserContext = createContext<TileImageTeaserContext>({
  mode: "image-top",
});

type TileImageTeaserProviderProps = {
  children: React.ReactNode;
  mode: TileImageTeaserMode;
};

const TileImageTeaserProvider = ({
  children,
  mode,
}: TileImageTeaserProviderProps): JSX.Element => (
  <TileImageTeaserContext.Provider value={{ mode }}>
    {children}
  </TileImageTeaserContext.Provider>
);

const useTileImageTeaser = (): TileImageTeaserContext => {
  const context = useContext(TileImageTeaserContext);

  if (context === undefined) {
    throw new Error(
      "useTileImageTeaser must be used within a TileImageTeaserProvider"
    );
  }

  return context;
};

export { TileImageTeaserContext, useTileImageTeaser, TileImageTeaserProvider };
